// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"657":"01fe2bb5","900":"44e12760"}[chunkId] + ".chunk.js";
};